module.exports = __webpack_public_path__ + "img/presentation-chart.11b79734.svg";